module.exports = __webpack_public_path__ + "static/media/data.a3f371f7.webp";